import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SelectBox from '../components/SelectBox';
import Button from 'react-bootstrap/Button';
import {
  TrackCompliantFilterType,
  LocationFilterType,
  ColXsMdType,
} from '../utils/Types';
import { DEFAULT_OPTION, DEFAULT_OPTION_LOCATION } from '../utils/Constant';
import KDateRangePicker from '../components/KDateRangePicker';
import { DateRange } from 'mui-daterange-picker-plus';
import LocationFilter from './LocationFilter';
import { useAppDispatch, useAppSelector } from '../store/redux-hooks';
import {
  getSeverityTypes,
  getStatusDrops,
  getEmployeeList,
  trackComplaintsSelector,
} from '../features/trackComplaintsSlice';
import {
  getFollowUpStatusDefault,
  moduleIds,
} from '../pages/compliant/TrackCompliantHelper';

interface ITrackCompliantFilterProps {
  onApplyFilters: (TrackCompliantFilter: TrackCompliantFilterType) => void;
}

const defaultFilterDate: TrackCompliantFilterType = {
  state: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  startDate: new Date(),
  endDate: new Date(),
  assignTo: DEFAULT_OPTION,
  severity: DEFAULT_OPTION_LOCATION,
  status: DEFAULT_OPTION,
  zone: DEFAULT_OPTION_LOCATION,
};
const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};
const TrackCompliantFilter: React.FunctionComponent<
  ITrackCompliantFilterProps
> = ({ onApplyFilters }) => {
  const severityOption = useAppSelector(
    trackComplaintsSelector
  ).severityOptions;
  const assigneeOptions = useAppSelector(
    trackComplaintsSelector
  ).employeeNameOptions;
  const statusOption = useAppSelector(trackComplaintsSelector).statusOptions;
  const [filter, setFilter] =
    useState<TrackCompliantFilterType>(defaultFilterDate);
  const dispatch = useAppDispatch();

  const onResetFilter = () => {
    const filterOptions: TrackCompliantFilterType = getFollowUpStatusDefault(
      statusOption,
      defaultFilterDate
    );
    onApplyFilters(filterOptions);
    setFilter(filterOptions);
  };

  useEffect(() => {
    dispatch(getSeverityTypes());
    dispatch(getStatusDrops({ module: moduleIds.status }));
    dispatch(getEmployeeList());
  }, []);

  useEffect(() => {
    const tout = setTimeout(() => {
      if (statusOption?.length) {
        const filterOptions: TrackCompliantFilterType =
          getFollowUpStatusDefault(statusOption, filter);
        setFilter(filterOptions);
      }
    }, 1000);
    return () => {
      clearTimeout(tout);
    };
  }, [statusOption]);

  return (
    <div className="border rounded ps-3 pt-2 pe-3">
      <Row>
        <Col xs={6} md={3}>
          <SelectBox
            label="Assigned To"
            value={filter.assignTo}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                assignTo: e,
              });
            }}
            options={assigneeOptions}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Severity"
            value={filter.severity}
            options={[DEFAULT_OPTION_LOCATION, ...severityOption]}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                severity: e,
              });
            }}
            showClear={false}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          <LocationFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: filter.zone,
              state: filter.state,
              district: filter.district,
              city: filter.city,
            }}
            setLocationFilter={(locationFilter: LocationFilterType) => {
              setFilter({
                ...filter,
                zone: locationFilter.zone,
                state: locationFilter.state,
                district: locationFilter.district,
                city: locationFilter.city,
              });
            }}
          />
        </Col>
        <Col xs={12} md={3}>
          <KDateRangePicker
            onApply={(dateRange: DateRange) => {
              setFilter({
                ...filter,
                startDate: dateRange.startDate,
                endDate: dateRange.endDate,
              });
            }}
            startDate={filter.startDate}
            endDate={filter.endDate}
          />
        </Col>
        <Col xs={6} md={3}>
          <SelectBox
            label="Status"
            value={filter.status}
            options={statusOption}
            onChange={(e: any) => {
              setFilter({
                ...filter,
                status: e,
              });
            }}
            showClear={false}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={4}>
          <div className="d-flex justify-content-left mb-3 pt-1">
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => {
                onApplyFilters(filter);
              }}
            >
              Search
            </Button>
            <Button
              variant="outline-primary"
              className="mx-2 cl-btn-outline-primary"
              onClick={() => {
                onResetFilter();
              }}
            >
              Reset
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TrackCompliantFilter;
